import React, { useContext, useState, useEffect } from 'react';
import {AuthContext} from "context/authProvider";
import avatar from 'assets/img/default.jpg';
import { Link } from 'react-router-dom';
import './Topbar.scss'


function Topbar() {

    const {auth} = useContext(AuthContext);
    const loggedIn = auth && auth.name ? true : false;
    const profileLabel = loggedIn ? auth.name : "Sign in";
    const [menuState, setMenuState] = useState(false)

    useEffect(() => {

    },[])
    const toggleMenu = () => {
        setMenuState(!menuState);
    }

    return (
        <nav className="navbar navbar-top navbar-expand navbar-light bg-secondary border-bottom">
          <div className="container-fluid">
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav align-items-center ml-md-auto">
              {/*
                <li className="nav-item d-xl-none">
                  <div className="pr-3 sidenav-toggler sidenav-toggler-light" data-action="sidenav-pin" data-target="#sidenav-main">
                    <div className="sidenav-toggler-inner">
                      <i className="sidenav-toggler-line"></i>
                      <i className="sidenav-toggler-line"></i>
                      <i className="sidenav-toggler-line"></i>
                    </div>
                  </div>
                </li>
                <li className="nav-item dropdown language-drop">
                  <div id="lang_selector" className="language-dropdown">
                    <label htmlFor="toggle" className="lang-flag lang-en" title="Click to select the language">
                      <span className="flag"></span>
                    </label>
                    <ul className="lang-list">
                      <li className="lang lang-en selected" title="EN">
                        <span className="flag"></span>
                      </li>
                      <li className="lang lang-cn" title="CN">
                        <span className="flag"></span>
                      </li>
                    </ul>
                  </div>
                </li>
              */}
              </ul>
              <ul className="navbar-nav align-items-center ml-auto ml-md-0">
                <li className="nav-item dropdown">
                  {/*
                  <Link to={loggedIn ? "/" : "/Signin"} className="nav-link pr-0">
                  */}
                    <div className="media align-items-center" onClick={toggleMenu}>
                      <span className="avatar avatar-sm rounded-circle">
                        <img src={avatar} className="rounded-circle"></img>
                      </span>
                      <div className="media-body ml-2 d-none d-lg-block">
                        <span className="mb-0 text-sm font-weight-bold">{profileLabel}</span>
                      </div>
                    </div>
                  {/*
                  </Link>
                  */}
                  <div className={`dropdown-menu dropdown-menu-right ${ menuState ? 'show' : ''}`}>
                    {/*
                    <div className="dropdown-header noti-title">
                      <h6 className="text-overflow m-0">Welcome!</h6>
                    </div>
                    */}
                    <Link onClick={toggleMenu} to="/myProfile" className="dropdown-item">
                      <i className="ni ni-single-02"></i>
                      <span>My profile</span>
                    </Link>
                    <a href="https://www.zuragon.com/help/#support" target="_blank" className="dropdown-item">
                        <i className="ni ni-support-16"></i>
                        <span>Support Center</span>
                    </a>
                    <a href="https://www.zuragon.com/downloads/" target="_blank" className="dropdown-item">
                        <i className="ni ni-cloud-download-95"></i>
                        <span>Download Center</span>
                    </a>
                    <div className="dropdown-divider"></div>
                    <Link to="/logout" className="dropdown-item">
                      <i className="ni ni-user-run"></i>
                      <span>Logout</span>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </nav>
    )

}
export default Topbar;